import React, { useEffect, useState, useCallback } from "react";
import { Container, Form, Message, Segment, Table } from "semantic-ui-react";
import { NavLink } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import { NotificationPopPup } from "../../campaigns/New";
import { useAuth } from "../../../../AuthenticationStore";
import { useForm, useFieldArray } from "react-hook-form";

let optionsDueDays = [...Array(30).keys()];

optionsDueDays = optionsDueDays.map(item => {
  const day = item + 1;
  return { key: day, text: day, value: day };
});

const Campaigns = () => {
  const { configurationService, loanService } = useAuth();
  const [loading, setLoading] = useState(true);

  const { register, control, handleSubmit } = useForm({});
  const { fields, append, remove } = useFieldArray({
    control,
    name: "appClients"
  });

  const [dueDay, setDueDay] = useState([]);
  const onChangeDueDay = useCallback(
    (_, newValue) => {
      setDueDay(newValue.value);
    },
    [setDueDay]
  );

  const [daysQueryCentralRisk, setDaysQueryCentralRisk] = useState(0);
  const onChangeDaysQueryCentralRisk = useCallback(
    (_, newValue) => setDaysQueryCentralRisk(newValue.value),
    [setDaysQueryCentralRisk]
  );

  const [daysUpdateData, setDaysUpdateData] = useState(0);
  const onChangeDaysUpdateData = useCallback(
    (_, newValue) => setDaysUpdateData(newValue.value),
    [setDaysUpdateData]
  );

  const [guaranteeType, setGuaranteeType] = useState("");
  const onChangeGuaranteeType = useCallback(
    (_, newValue) => setGuaranteeType(newValue.value),
    [setGuaranteeType]
  );

  const [nameDestination, setNameDestination] = useState("");

  const [originalConfiguration, setOriginalConfiguration] = useState({});

  const [loans, setLoans] = useState([]);
  const [destinations, setDestinations] = useState({});

  const [loanType, setLoanType] = useState("");
  const onChangeLoanType = useCallback(
    (_, newValue) => setLoanType(newValue.value),
    [setLoanType]
  );

  const [loanDestination, setLoanDestination] = useState("");
  const onChangeLoanDestination = useCallback(
    (_, newValue) => {
      const nameDestinationSelected = newValue.options.find(
        item => item.value === newValue.value
      );
      setLoanDestination(newValue.value);
      setNameDestination(nameDestinationSelected.text);
    },
    [setLoanDestination]
  );

  useEffect(() => {
    if (!configurationService) return;

    const getConfiguration = async () => {
      getList();

      const responseCompany = await configurationService.getConfiguration();
      if (
        responseCompany.object &&
        responseCompany.object.generalConfiguration
      ) {
        setDaysQueryCentralRisk(
          responseCompany.object.generalConfiguration.daysQueryCentralRisk
        );
        setDaysUpdateData(
          responseCompany.object.generalConfiguration.daysUpdateData
        );
        setGuaranteeType(
          responseCompany.object.generalConfiguration.guaranteeType
        );
        setNameDestination(
          responseCompany.object.generalConfiguration.nameDestination
        );
        setLoanDestination(
          responseCompany.object.generalConfiguration.loanDestination
        );

        setLoanType(responseCompany.object.generalConfiguration.loanType);

        setDueDay(responseCompany.object.generalConfiguration.dueDay);

        // apps cliente
        const appsClientsResponse = responseCompany.object.generalConfiguration.appClients;
        if (appsClientsResponse) {
          for (let i = 0; i < appsClientsResponse.length; i++) {
            const client = appsClientsResponse[i];
            append(client)
          }
        }
        
        setOriginalConfiguration(responseCompany.object);
        setLoading(false);
      }
    };
    getConfiguration();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [configurationService]);

  const getList = async () => {
    loanService
      .getLoanType()
      .then(res => {
        if (res.cdExceptions.length > 0) {
          const errors = [];
          for (let index = 0; index < res.cdExceptions.length; index++) {
            errors.push(res.cdExceptions[index]["exception"]);
          }
          messagesExepctions(errors);
          setLoans([]);
          setDestinations({});
          return;
        }

        let destinationsObject = {};

        const optionsAttributeTemp = res.object.map((item, key) => {
          destinationsObject[item.loanTypeCode] = item.destinations.map(
            (itemLoan, keyLoan) => {
              return {
                key: keyLoan,
                text: itemLoan.loanDestinationName,
                value: itemLoan.loanDestinationCode
              };
            }
          );

          return { key, text: item.loanTypeName, value: item.loanTypeCode };
        });

        setLoans(optionsAttributeTemp);
        setDestinations(destinationsObject);
      })
      // eslint-disable-next-line no-console
      .catch(err => console.log(err));
  };

  const saveConfiguration = async data => {
    setLoading(true);
    const generalConfig = Object.assign(originalConfiguration, {});
    if (!generalConfig.generalConfiguration)
      generalConfig.generalConfiguration = {};

    generalConfig.generalConfiguration.daysQueryCentralRisk = daysQueryCentralRisk;
    generalConfig.generalConfiguration.daysUpdateData = daysUpdateData;
    generalConfig.generalConfiguration.guaranteeType = guaranteeType;
    generalConfig.generalConfiguration.nameDestination = nameDestination;
    generalConfig.generalConfiguration.loanType = loanType;
    generalConfig.generalConfiguration.loanDestination = loanDestination;
    generalConfig.generalConfiguration.dueDay = dueDay;
    generalConfig.generalConfiguration.appClients = data.appClients;

    const responseSveConfig = await configurationService.saveConfiguration(
      generalConfig
    );

    let messages = [];
    if (responseSveConfig && responseSveConfig.cdExceptions) {
      for (let i = 0; i < responseSveConfig.cdExceptions.length; i++) {
        messages.push(responseSveConfig.cdExceptions[i]["exception"]);
      }
      setMessagesExepctions(messages);
    }

    if (messages.length === 0) {
      setShowToast(true);
      setTimeout(() => setShowToast(false), 500);
    }

    setLoading(false);
  };

  const [messagesExepctions, setMessagesExepctions] = useState([]);
  const handleDismissExceptions = () => setMessagesExepctions([]);
  // toast
  const [showToast, setShowToast] = useState(false);

  const validateDaysUpdateData = () => {
    if (daysUpdateData <= -1) setDaysUpdateData(0);
  };

  const validateDaysQueryCentralRisk = () => {
    if (daysQueryCentralRisk <= -1) setDaysQueryCentralRisk(0);
  };

  return (
    <Container>
      <div className="card">
        <div className="card-body">
          <ToastProvider>
            <NotificationPopPup showToast={showToast} />
          </ToastProvider>
          {messagesExepctions.length > 0 ? (
            <Message
              onDismiss={handleDismissExceptions}
              error
              header="Errores al guardar"
              list={messagesExepctions}
            />
          ) : null}
          
          <Segment>
            <Form>
              <Form.Group widths="equal">
                <Form.Select
                  fluid
                  label="Línea Campaña"
                  options={loans}
                  placeholder="Línea Campaña"
                  value={loanType}
                  onChange={onChangeLoanType}
                />

                <Form.Select
                  fluid
                  label="Destino Campaña"
                  options={destinations[loanType] || []}
                  placeholder="Destino Campaña"
                  value={loanDestination}
                  onChange={onChangeLoanDestination}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Select
                  fluid
                  label="Día de corte"
                  multiple
                  search
                  options={optionsDueDays}
                  onChange={onChangeDueDay}
                  value={dueDay}
                />

                <Form.Input
                  fluid
                  label="Tipo de Garantía"
                  value={guaranteeType}
                  onChange={onChangeGuaranteeType}
                />
              </Form.Group>
              <Form.Group widths="equal">
                <Form.Input
                  type="number"
                  fluid
                  label="Nro días actualización datos"
                  value={daysUpdateData}
                  onChange={onChangeDaysUpdateData}
                  onBlur={validateDaysUpdateData}
                />
                <Form.Input
                  type="number"
                  fluid
                  label="Nro días consulta centrales"
                  value={daysQueryCentralRisk}
                  onChange={onChangeDaysQueryCentralRisk}
                  onBlur={validateDaysQueryCentralRisk}
                />
              </Form.Group>
            </Form>
            <form onSubmit={handleSubmit(data => saveConfiguration(data))} id="formClients">
              <Table>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell colSpan="4">
                      <h2>
                        Apps clientes
                        <button
                          type="button"
                          className="btn btn-primary"
                          style={{float: "right"}}
                          onClick={() => append({ enabled: true })}
                        >
                          Agregar cliente
                        </button>
                      </h2>
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Identificador</Table.HeaderCell>
                    <Table.HeaderCell>Descripción</Table.HeaderCell>
                    <Table.HeaderCell>Activo</Table.HeaderCell>
                    <Table.HeaderCell></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {fields.map((item, index) => (
                    <Table.Row key={item.id}>
                      <Table.Cell>
                        <input
                          name={`appClients[${index}].clientId`}
                          defaultValue={item.clientId}
                          ref={register()}
                          style={{border: "1px #ddd solid", width: "100%"}}
                        />
                      </Table.Cell>
                      
                      <Table.Cell>
                        <input
                          name={`appClients[${index}].description`}
                          defaultValue={item.description}
                          ref={register()}
                          style={{border: "1px #ddd solid", width: "100%"}}
                        />
                      </Table.Cell>

                      <Table.Cell>
                        <input name={`appClients[${index}].enabled`} defaultChecked={item.enabled} ref={register()} type="checkbox" />
                      </Table.Cell>

                      <Table.Cell>
                        <button
                          type="button"
                          className="btn btn-outline-danger"
                          style={{float: "right", padding: "5px"}}
                          onClick={() => remove(index)}  
                        >
                          <i className="mdi mdi-delete"></i>
                        </button>
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </form>      
          </Segment>
          <button
            className="btn btn-primary"
            disabled={loading}
            onClick={() => {
              const formClients = document.querySelector("#formClients")
              formClients.dispatchEvent(new Event('submit', { cancelable: true }))
            }}
          >
            Guardar
          </button>
          &nbsp;&nbsp;
          <NavLink className="btn btn-danger" to="/campaigns">
            Salir
          </NavLink>
        </div>
      </div>
    </Container>
  );
};

export default Campaigns;
export { optionsDueDays };
